import type { FunctionComponent } from 'react';

import { Button } from '@/core/tamagoshi/Button/Button';

import type { ThemedButtonProps } from './ThemedButtonProps';

export const ThemedButton: FunctionComponent<ThemedButtonProps> = (props) => (
  <Button {...props} theme="default" />
);

ThemedButton.displayName = Button.displayName;
